module.exports = __webpack_public_path__ + "static/img/saomaguanzhu.aafb0c4c.png";